// One shape for a note from any of the five places notes live, so one
// component (Components/Work/EditableNote.js) renders them all:
//   { id, text, by, at, mine, editedAt, editedBy, history, mirror }
// ADO #4318 added everything after `at`: `mine` is the server's author check
// (never decided here), `history` the earlier versions newest first -- null
// when they couldn't be read, never [] -- and `mirror` whether the DevOps
// comment / Monday update copy kept up: 'ok', 'failed', or null when not
// recorded. Kept apart from workService so a dialog can use it without
// pulling in the whole work client.

export const normaliseWorkNote = (n) => ({
    id: n.note_id || '', text: n.text || '', by: n.by || '', at: n.at_utc || '',
    mine: !!n.mine, editedAt: n.edited_at_utc || '', editedBy: n.edited_by || '',
    history: Array.isArray(n.history) ? n.history.map((h) => ({ text: h.text || '', by: h.by || '', at: h.at_utc || '' })) : null,
    mirror: n.mirror || null,
});

export const normaliseTodoNote = (n) => ({
    id: n.id || '', text: n.note || '', by: n.createdBy || '', at: n.createdOn || '',
    mine: !!n.mine, editedAt: n.edited ? (n.updatedOn || '') : '', editedBy: n.edited ? (n.updatedBy || '') : '',
    history: Array.isArray(n.history) ? n.history.map((h) => ({ text: h.note || '', by: h.by || '', at: h.on || '' })) : null,
    mirror: null,
});

export const normaliseRequestNote = (n) => ({
    id: n.NexusSuccessRequestNote_Id || '', text: n.Comment || '', by: n.CreatedBy || '', at: n.CreatedOn || '',
    mine: !!n.mine, editedAt: n.edited ? (n.UpdatedOn || '') : '', editedBy: n.edited ? (n.UpdatedBy || '') : '',
    history: Array.isArray(n.history) ? n.history.map((h) => ({ text: h.Comment || '', by: h.WrittenBy || '', at: h.WrittenOn || '' })) : null,
    mirror: null,
});

// Meeting notes share the ledger shape; they have no copy elsewhere.
export const normaliseMeetingNote = (n) => ({ ...normaliseWorkNote(n), mirror: null });
